/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const checkValue = (value: string | undefined) =>
  value?.length === 0 ? null : value;
